// extracted by mini-css-extract-plugin
export default {"table":"VerificationStatisticTable_table__LTD8U"};